import { useEffect, useState } from 'react'

/** True when <html> carries the `dark` class (set by useTheme). Tracks changes via MutationObserver. */
export function useDocumentDark() {
  const [dark, setDark] = useState(false)
  useEffect(() => {
    const root = document.documentElement
    const update = () => setDark(root.classList.contains('dark'))
    update()
    const mo = new MutationObserver(update)
    mo.observe(root, { attributes: true, attributeFilter: ['class'] })
    return () => {
      mo.disconnect()
    }
  }, [])
  return dark
}
